import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface Record {
  [key: string]: any;
}

interface SubmitableEventArgs {
  record: Record;
  abort: Function;
}

class SubmitEvent extends EventData<Submitable> implements SubmitableEventArgs {
  record: Record;
  abort: Function;

  constructor({ record, abort }: SubmitableEventArgs = { record: {}, abort: Function }) {
    super();

    this.record = record;
    this.abort = abort;
  }
}

class SubmitEventListener extends EventListener<Submitable, SubmitEvent, SubmitableEventArgs> {
  constructor() {
    super(SubmitEvent);
  }
}

export default interface Submitable extends Mountable {

  /** @event */
  onBeforeSubmit: SubmitEventListener;

  /** @event */
  onSubmit: SubmitEventListener;

  /** @event */
  onBeforeCancel: SubmitEventListener;

  /** @event */
  onCancel: SubmitEventListener;

  submit(): void;
  cancel(): void;
}

export { SubmitEventListener, SubmitEvent };
